const parseUri = require('parse-uri');
const {buildUrl, islocalizationRequired, validateSiteContextBasePath} = require('./localizeUrlHelper');

const PATH_PREFIX = '/';


// eslint-disable-next-line complexity
function getLocalizedPath(urlPath, basePath) {
    // This will take pathname and siteContext({basePath, hostname}) and will return localized path.
    // For Example : If url pathname is /search and basePath is /en-ca,
    // it will return path - /en-ca/search

    if (basePath && urlPath.indexOf(basePath) !== 0) {
        return urlPath !== PATH_PREFIX ? `${basePath}${urlPath}` : basePath;
    }

    return urlPath;
}

/**
 * This function returns localized url according to provided basePath from siteContext.
 * It returns relative url if input is relative, and absolute url if input is absolute.
 * For relative url, please make sure it starts with '/'.
 * To localize relative url to absolute, set options with {absolute: true}
 *
 * @param url Absolute/relative url to be localized. Relative url must starts with '/'.
 * @param siteContext(basePath,hostname) Site context information, including basePath and hostname.
 * @param options \{absolute: true\} returns absolute localized url
 * @returns string
 */
// eslint-disable-next-line complexity
const localizeUrl = (url, siteContext = {}, options = {}) => {
    if (!islocalizationRequired(url, siteContext)) {
        return url;
    }
    // validate base path and log if missing
    validateSiteContextBasePath(siteContext);

    const parsedUrl = parseUri(url);
    let path = getLocalizedPath(parsedUrl.relative, siteContext.basePath);

    if (parsedUrl.authority || options.absolute) {
        return buildUrl(url, parsedUrl, siteContext, path);
    }
    return path;
};

module.exports = {
    localizeUrl
};
